import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

interface LecturerLayoutState {
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

/**
 * Store to manage the layout state for the Lecturer role.
 * Persists the sidebar collapse state.
 * Default: Sidebar is EXPANDED on first load.
 */
export const useLecturerLayoutStore = create<LecturerLayoutState>()(
  persist(
    (set) => ({
      isSidebarCollapsed: false, // Always start expanded
      toggleSidebar: () => set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed })),
      setSidebarCollapsed: (collapsed: boolean) => set({ isSidebarCollapsed: collapsed }),
    }),
    {
      name: 'lecturer-layout-storage-v2', // v2 to reset any old collapsed states
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
);
